import { useMemo } from "react"
import { dateFormat } from "shared/util"
import { FetchState } from "shared/api"

import { LvProjectResultList } from "interface/carenet/lv"

import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
  Stack,
  Typography
} from "@mui/material"

import { Loading } from "components/controls/loading"

const empty = "**"

type LvProjectSelectProps = {
  projectsState: FetchState<LvProjectResultList>
  projectCode: string | null
  setProjectCode: (projectCode: string | null) => void
  maxWidth?: string
}
export const LvProjectSelect = ({
  projectsState,
  projectCode,
  setProjectCode,
  maxWidth
}: LvProjectSelectProps) => {
  const projects = useMemo(
    () => {
      if (projectsState.loading) return []
      const projects = projectsState.data?.list || []
      projects.sort((a, b) => (b.broadcastStartDate ?? '').localeCompare(a.broadcastStartDate ?? ''))
      return projects
    },
    [projectsState]
  )
  return (
    <FormControl sx={{ position: 'relative' }}>
      {projectsState.loading && <Loading/>}
      <InputLabel id="lv-project-code-label">Web講演会</InputLabel>
      <Select
        id="lv-project-code"
        labelId="lv-project-code-label"
        label="Web講演会"
        size="small"
        fullWidth
        value={projectCode ?? empty}
        onChange={
          (event) => setProjectCode(
            event.target.value === empty ? null : event.target.value
          )
        }
        renderValue={(selected) => {
          if (selected === empty) return "未選択"
          const project = projects.find((project) => project.projectCode === selected)
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: project?.projectName ?? 'empty'
              }}
              style={{
                whiteSpace: 'nowrap',
                maxWidth,
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            />
          )
        }}
      >
        <MenuItem key={`choice-empty`} value={empty}>
          未選択
        </MenuItem>

        { projects.map((project) => (
          <MenuItem key={`lv-project-${project.projectCode}`} value={project.projectCode}>
            <Stack direction="row" spacing={0.5} alignItems="center" width="100%">
              <Typography variant="body2" color="text.secondary" width="8em">{dateFormat(project.broadcastStartDate, { wareki: false })}</Typography>
              <div
                dangerouslySetInnerHTML={{
                  __html: project.projectName ?? 'empty'
                }}
                style={{
                  whiteSpace: 'nowrap',
                  maxWidth: '50vw',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  flexGrow: 1
                }}
              />
              <Typography variant="body2" color="text.secondary">{project.productName}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
